import Vue from 'vue'
import Router from 'vue-router'

import Message from '../pages/message.vue'
import Community from '../pages/community.vue'
import My from '../pages/my.vue'
import MyProfile from '../pages/my/profile.vue'
import MyTransfer from '../pages/my/transfer.vue'
import MyReceive from '../pages/my/receive.vue'
import MyWechat from '../pages/my/wechat.vue'
import MyService from '../pages/my/service.vue'
import MySelfOrder from '../pages/my/self.vue'
import MySelfCarry from '../pages/my/selfCarry.vue'
import MyPhoneOrder from '../pages/my/phoneOrder.vue'
import MyPhoneOrderCarry from '../pages/my/phoneOrderCarry.vue'
import MyVerify from '../pages/my/verify.vue'
import MyStatus from '../pages/my/status.vue'
import MyStation from '../pages/my/station.vue'
import MySupplier from '../pages/my/supplier.vue'
import MyServiceEdit from '../pages/my/serviceEdit.vue'

import Login from '../pages/login.vue'
import Register from '../pages/register.vue'
import Elder from '../pages/elder.vue'
import ElderDetail from '../pages/elderDetail.vue'
import ElderBasic from '../pages/elder/basic.vue'
import ElderExtend from '../pages/elder/extend.vue'
import ElderBuzhu from '../pages/elder/buzhu.vue'
import ElderFamily from '../pages/elder/family.vue'
import ElderFamilyChildren from '../pages/elder/familyChildren.vue'
import ElderDemand from '../pages/elder/demand.vue'
import ElderHealthy from '../pages/elder/healthy.vue'
import ElderTransfer from '../pages/elder/transfer.vue'

import Service from '../pages/service.vue'
import Service2 from '../pages/service2.vue'
import MessageInfo from '../pages/message/messageInfo.vue'
import MessageList from '../pages/message/messageList.vue'

import AlarmInfo from '../pages/alarm/alarmInfo.vue'
import AlarmList from '../pages/alarm/alarmList.vue'

import Self from '../pages/self.vue'
import Self2 from '../pages/self2.vue'



Vue.use(Router)

const vueRouter = new Router({

    mode:'history',

    routes: [
        {
            path: "/", component: Message,meta:{navShow:true,tab:'message',login_require:true}
        }, {
            path:"/login",component:Login
        }, {
            path:"/register",component:Register
        }, {
            path: '/community', component: Community,meta:{navShow:true,tab:'community',login_require:true}
        }, {
            path: '/my', component: My,meta:{navShow:true,tab:'my',login_require:true}
        }, {
            path: '/my/profile', component: MyProfile,meta:{ login_require:true}
        },{
            path: '/my/transfer', component: MyTransfer,meta:{ login_require:true}
        },{
            path: '/my/receive', component: MyReceive,meta:{ login_require:true}
        },{
            path: '/my/wechat', component: MyWechat,meta:{ login_require:true}
        },{
            path: '/my/service', component: MyService,meta:{ login_require:true}
        },{
            path: '/my/self', component: MySelfOrder,meta:{ login_require:true}
        },{
            path: '/my/selfCarry/:id', component: MySelfCarry,meta:{ login_require:true}
        },{
            path: '/my/phone_order', component: MyPhoneOrder,meta:{ login_require:true}
        },{
            path: '/my/phone_order_carry/:id', component: MyPhoneOrderCarry,meta:{ login_require:true}
        },{
            path: '/my/serviceEdit/:id', component: MyServiceEdit,meta:{ login_require:true}
        }, {
            path: '/my/verify', component: MyVerify,meta:{ login_require:true}
        }, {
            path: '/my/status', component: MyStatus,meta:{ login_require:true}
        }, {
            path: '/my/station', component: MyStation,meta:{ login_require:true}
        }, {
            path: '/my/supplier', component: MySupplier,meta:{ login_require:true}
        }, {
            path: '/elder/:id', component: Elder,meta:{ login_require:true}
        }, {
            path: '/elder/detail/:id', component: ElderDetail,meta:{ login_require:true}
        }, {
            path: '/elder/basic/:id', component: ElderBasic,meta:{ login_require:true}
        }, {
            path: '/elder/extend/:id', component: ElderExtend,meta:{ login_require:true}
        }, {
            path: '/elder/buzhu/:id', component: ElderBuzhu,meta:{ login_require:true}
        }, {
            path: '/elder/family/children/:id', component: ElderFamilyChildren,meta:{ login_require:true}
        }, {
            path: '/elder/family/:id', component: ElderFamily,meta:{ login_require:true}
        }, {
            path: '/elder/demand/:id', component: ElderDemand,meta:{ login_require:true}
        }, {
            path: '/elder/healthy/:id', component: ElderHealthy,meta:{ login_require:true}
        }, {
            path: '/elder/transfer/:id', component: ElderTransfer,meta:{ login_require:true}
        }, {
            path: '/service/:type', component: Service,meta:{ login_require:true}
        }, {
            path: '/service2', component: Service2,meta:{ login_require:true}
        }, {
            path: '/self', component: Self,meta:{ login_require:true}
        }, {
            path: '/self2', component: Self2,meta:{ login_require:true}
        }, {
            path: '/message/:id', component: MessageInfo,meta:{ login_require:true}
        }, {
            path: '/messageList', component: MessageList,meta:{ login_require:true}
        }, {
            path: '/alarm/:id', component: AlarmInfo,meta:{ login_require:true}
        }, {
            path: '/alarm', component: AlarmList,meta:{ login_require:true}
        }
    ]
});

vueRouter.beforeEach((to,from,next) => {

    const login_require = to.meta.login_require;

    /*测试需要*/
   /* const userInfo = JSON.stringify({openid:'oh_QtwdMN2NBKkGDyQUXXbdWTA7I',wechatInfo:{headimgurl:''}})
    window.localStorage.setItem('UserInfo',userInfo) */

    // 判断该路由是否需要登录权限
    if (login_require === true) {
        if (window.localStorage.getItem('UserInfo')) {
            next()
        } else {
            let redirectHref = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='
                + 'wxcf65bcd4da028bb7'
                + '&redirect_uri='
                + encodeURIComponent('http://wechat.guenyanglao.com/login')
                + '&response_type=code&scope=snsapi_userinfo&state=STATE'
                +'#wechat_redirect';
            window.location.href = redirectHref;
        }
    } else {

        let locationUrl = window.location.href;
        if(locationUrl.indexOf("code") >= 0){

        }else{
            let locationUrl = window.location.href;

            let redirectHref = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='
                + 'wxcf65bcd4da028bb7'
                + '&redirect_uri='
                + encodeURIComponent(locationUrl)
                + '&response_type=code&scope=snsapi_userinfo&state=STATE'
                +'#wechat_redirect';
            window.location.href = redirectHref;
        }
        next()  // 确保一定要有next()被调用
    }

});


/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
}

export default vueRouter;





// WEBPACK FOOTER //
// ./src/router/index.js